{{#if confirmationMessage }}
    <div class="hdg hdg_5">Success!</div>
    <p class="bdcpy">Thanks for your interest in the THD Home Services! We will reach out to you via email within 24-48 hours with your username and password to gain access to the site.</p>
{{else}}
    <div class="vr{{#if loading}} isLoading{{/if}}" style="padding: 0 20px;">
        <div>
            {{#if content}}<p class="bdcpy">{{removeMarkup content}}</p>{{/if}}
        </div>
        <form class="sfForm js-element--requestForm" id="vendor-account-form" action="">
            <div class="sfForm-row sfForm-row_2up">
                <div class="sfForm-row-item isRequired" id="firstName">
                    <label class="sfForm-lbl" for="firstName">First Name</label>
                    <input class="sfForm-input required" name="First Name" id="firstName" type="text">
                </div>
                <div class="sfForm-row-item isRequired" id="lastName">
                    <label class="sfForm-lbl" for="lastName">Last Name</label>
                    <input class="sfForm-input required" name="Last Name" id="lastName" type="text">
                </div>
            </div>
            <div class="sfForm-row">
                <div class="sfForm-row-item isRequired" id="email">
                    <label class="sfForm-lbl" for="email">Email</label>
                    <input class="sfForm-input required" name="Email" id="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}$" type="email">
                </div>
            </div>
            <div class="sfForm-row">
                <div class="sfForm-row-item" id="company">
                    <label class="sfForm-lbl" for="company">Company</label>
                    <input class="sfForm-input" name="Company" id="company" type="text">
                </div>
            </div>
            <div class="sfForm-row">
                <div class="sfForm-row-item isRequired" id="pvendor">
                    <label class="sfForm-lbl" for="pvendor">PVendor #</label>
                    <input class="sfForm-input required" name="PVendor" id="pvendor" type="number" inputmode="numeric" pattern="[0-9]*">
                </div>
            </div>
           {{#if metaDataOptions}}
                {{#each metaDataOptions}}
                    <div class="sfForm-row">
                        <div class="sfForm-row-item{{#if isRequired}} isRequired{{#with (lookup ../errors @index)}} sfForm-row-item_hasErrors{{/with}}{{/if}}" id="{{id}}">
                            <label class="sfForm-lbl" for="{{label}}">{{label}}</label>
                            {{#if isSelect}}
                                <select class="sfForm-input required js-element--userMetadata" data-metadata-label="{{label}}" name="{{label}}" id="{{label}}">
                                    <option value="">-- Select an Option --</option>
                                    {{#each (sort options 'label')}}
                                        <option value="{{value}}" {{#ifEquals ../value value}}selected="selected"{{/ifEquals}}>{{label}}</option>
                                    {{/each}}
                                </select>
                            {{/if}}
                            {{#unless isSelect}}
                                {{#unless isTextarea}}
                                    <input type="{{#if isCheckbox}}checkbox{{/if}}{{#if isDate}}date{{/if}}{{#if isText}}text{{/if}}"{{#if isCheckbox}}{{#if value}}checked{{/if}}{{/if}} class="sfForm-input js-element--userMetadata" data-metadata-label="{{label}}" name="{{label}}" id="{{label}}"{{#if value}}value="{{value}}"{{/if}} >
                                {{/unless}}
                            {{/unless}}
                            {{#if isTextarea}}
                                <textarea class="sfForm-input js-element--userMetadata" data-metadata-label="{{label}}" name="{{label}}" id="{{label}}" cols="30" rows="10">{{#if value}}{{value}}{{/if}}</textarea>
                            {{/if}}
                            <div class="sfForm-msg sfForm-msg_error">{{lookup ../errors @index}}</div>
                        </div>
                    </div>
                {{/each}}
            {{/if}}
            <div class="sfForm-row">
                <div class="sfForm-row-item">
                    <button type="button" class="btn btn_reversed" onclick="sendFormEmail('vendor-account-form', 'status')">Submit</button>
                </div>
            </div>
        </form>
    </div>
{{/if}}